// @mui
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function customShadows(mode = 'light') {
  const isLight = mode === 'light';

  // Equivalent of GREY[500]
  const baseGrey = isLight ? '#919EAB' : '#000000';

  const transparent = alpha(baseGrey, isLight ? 0.16 : 0.32);

  return {
    z1: `0 1px 2px 0 ${transparent}`,
    z4: `0 4px 8px 0 ${transparent}`,
    z8: `0 8px 16px 0 ${transparent}`,
    z12: `0 12px 24px -4px ${transparent}`,
    z16: `0 16px 32px -4px ${transparent}`,
    z20: `0 20px 40px -4px ${transparent}`,
    z24: `0 24px 48px 0 ${transparent}`,

    // brand shadows (keep colors same in both modes)
    primary: `0 8px 16px 0 ${alpha('#2065D1', 0.24)}`,
    info: `0 8px 16px 0 ${alpha('#2194FF', 0.24)}`,
    secondary: `0 8px 16px 0 ${alpha('#3366FF', 0.24)}`,
    success: `0 8px 16px 0 ${alpha('#54D62C', 0.24)}`,
    warning: `0 8px 16px 0 ${alpha('#FFC107', 0.24)}`,
    error: `0 8px 16px 0 ${alpha('#C53E39', 0.24)}`,

    // UI element shadows
    card: `0 0 2px 0 ${alpha(baseGrey, isLight ? 0.2 : 0.4)}, 
           0 12px 24px -4px ${alpha(baseGrey, isLight ? 0.12 : 0.24)}`,

    dialog: `-40px 40px 80px -8px ${alpha(baseGrey, isLight ? 0.24 : 0.48)}`,

    dropdown: `0 0 2px 0 ${alpha(baseGrey, isLight ? 0.24 : 0.48)}, 
               -20px 20px 40px -4px ${alpha(baseGrey, isLight ? 0.24 : 0.48)}`,
  };
}
